module.exports = __webpack_public_path__ + "media/img/sda/Virtual-Scholarship-Fair-post-banner-v2-d4a6e697763943eef1ddd36ac63361eb.jpg";